import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IconButtonComponent } from '@examdojo/core/icon-button';
import { IonContent, IonHeader, IonTitle, IonToolbar, ModalController } from '@ionic/angular/standalone';
import { TranslocoPipe } from '@jsverse/transloco';
import Panzoom from '@panzoom/panzoom';

@Component({
  selector: 'dojo-image-preview-dialog',
  templateUrl: './image-preview-dialog.component.html',
  styleUrl: './image-preview-dialog.component.scss',
  imports: [IonHeader, IonToolbar, IonTitle, IconButtonComponent, MatTooltipModule, TranslocoPipe, IonContent],
})
export class ImagePreviewDialogComponent implements AfterViewInit, OnDestroy {
  constructor(private readonly modalCtrl: ModalController) {}

  @Input() imageUrl?: string;
  @ViewChild('zoomImage', { static: false }) zoomImageRef!: ElementRef<HTMLImageElement>;

  private panzoom?: ReturnType<typeof Panzoom>;

  ngAfterViewInit() {
    if (this.zoomImageRef?.nativeElement) {
      setTimeout(() => this.initializePanzoom(), 100);
    }
  }

  ngOnDestroy() {
    if (this.panzoom) {
      this.panzoom.destroy();
    }
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  zoomIn() {
    this.panzoom?.zoom(this.panzoom.getScale() * 1.2);
  }

  zoomOut() {
    this.panzoom?.zoom(this.panzoom.getScale() * 0.8);
  }

  private initializePanzoom() {
    const imageElement = this.zoomImageRef.nativeElement;

    this.panzoom = Panzoom(imageElement, {
      maxScale: 4,
      minScale: 0.5,
      startScale: 1,
      cursor: 'grab',
      // Remove contain to allow free panning
      disablePan: false,
      disableZoom: false,
      panOnlyWhenZoomed: true,
    });

    // Enable wheel/touchpad zoom - the key for MacBook touchpads
    const parent = imageElement.parentElement;
    if (parent) {
      parent.addEventListener('wheel', this.panzoom.zoomWithWheel);
    }
  }
}
